module.exports = __webpack_public_path__ + "static/assets/8cbbbd86ab1bfbce14f821edb152a22c.svg";